import { capitalize } from '@/utils';
import { ADMIN_ROLE_KEY, STAFF_ROLE_KEY, SUPERVISOR_ROLE_KEY } from '@/utils/role';

export const SCHEDULE_TYPE_OPTIONS: readonly string[] = ['Full-time M–F', 'PRN', 'Weekend-only', 'Part-time'];

export const STAFF_ROLE_OPTIONS: readonly { value: string; label: string }[] = [
    { value: STAFF_ROLE_KEY, label: capitalize(STAFF_ROLE_KEY) },
    { value: SUPERVISOR_ROLE_KEY, label: capitalize(SUPERVISOR_ROLE_KEY) },
    { value: ADMIN_ROLE_KEY, label: capitalize(ADMIN_ROLE_KEY) }
];
